import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {useAuth} from "hooks/useAuth";
import Loading from "shared/ui/Loading";
import {APIGetEmailVerify, APIVerificationEmail} from "../api/login";

const EmailVerify = () => {
    const {update, tenant} = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState<boolean>(false);

    const tenantParams = searchParams.get("tenant");
    const url = searchParams.get("verify_url");
    const role = searchParams.get("role");
    const pass = searchParams.get("password");

    const hideNotification = () => {
        update("error", { show: false }, true);
    };

    const sendVerificationEmailHandler = (tenant: string, user: number) => {
        update("error", {}, true);
        setLoading(true);
        APIVerificationEmail({tenant, user})
            .then((response) => {
                if (response.data.success) {
                    update("error", {
                        show: true,
                        title: "E-mailul a fost trimis cu succes!",
                        message: "Verifică adresa de e-mail pentru recuperarea codului de verificare.",
                        icon: "fat envelope",
                        closable: true,
                        button: "Închide",
                        returnFunction: () => {
                            hideNotification();
                            navigate("/");
                        },
                    });
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch(() => update("error", {show: true, code: "A001"}))
            .finally(() => setLoading(false));
    };

    const showNotification = (config: any) => {
        update("error", {
            show: true,
            icon: "fat envelope",
            closable: true,
            ...config,
        });
    };

    const handleSuccessNotification = (message: string, passwordUrl?: string) => {
        if (tenantParams === "teacher" && role === "teacher") {
            showNotification({
                title: message,
                message: "Accesează contul apăsând pe butonul de mai jos.",
                button: "Autentificare",
                returnFunction: () => {
                    hideNotification();
                    navigate("/login/profesori");
                },
            });
        } else if (pass === "1") {
            showNotification({
                title: message,
                message: "Accesează contul apăsând pe butonul de mai jos.",
                button: "Autentificare",
                returnFunction: () => {
                    hideNotification();
                    navigate("/");
                },
            });
        } else {
            if(!passwordUrl) {
                showNotification({
                    title: message,
                    // message: "Apasă pe butonul de mai jos pentru a seta parola.",
                    button: "Autentificare",
                    returnFunction: () => {
                        hideNotification();
                        window.location.replace("/");
                    },
                });
            } else {
                showNotification({
                    title: message,
                    message: "Apasă pe butonul de mai jos pentru a seta parola.",
                    button: "Setează parola",
                    returnFunction: () => {
                        hideNotification();
                        window.location.replace(passwordUrl || "");
                    },
                });
            }
        }
    };

    const showExpirationError = (message: string, tenant: string, user: number) => {
        update("error", {
            show: true,
            title: message,
            message: "Apasă pe butonul de mai jos pentru retrimiterea acestuia.",
            button: "Trimite e-mail",
            icon: "fat face-eyes-xmarks",
            closable: false,
            onClickFunction: () => sendVerificationEmailHandler(tenant, user),
        });
    }

    const showDefaultMessage = () => {
        showNotification({
            title: "Verifică adresa de e-mail",
            message: "Verifică-ți adresa de e-mail pentru validarea contului.",
            button: "ÎNCHIDE",
            returnFunction: () => {
                navigate(tenant.type === "teacher" ? "/login/profesori" : "/");
            },
        });
    }

    useEffect(() => {
        if (!url) {
            showDefaultMessage();
            return;
        }

        setLoading(true);
        APIGetEmailVerify(url)
            .then((response) => {
                if (response.data.success) {
                    handleSuccessNotification(response.data.data.message, response.data.data.password_url);
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch((err) => {
                if (err.response.status === 410) {
                    const { message, tenant: tId, user: uId } = err.response.data.data;
                    showExpirationError(message, tId, uId);
                } else {
                    update("error", {show: true, code: "A001",});
                }
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box component="main">
            <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="stretch" mt={0}>
                {loading && <Loading modal={true} show={true}/>}
            </Grid>
        </Box>
    );
};

export default EmailVerify;
